// extracted by mini-css-extract-plugin
module.exports = {"sectionBody":"TaxAllocationAppendixTab__sectionBody--pfUL3","totalLabel":"TaxAllocationAppendixTab__totalLabel--3w9YE","noData":"TaxAllocationAppendixTab__noData--14JFW"};